/* global axios */
import ApiClient from './ApiClient';

class TicketsAPI extends ApiClient {
  constructor() {
    super('tickets', { accountScoped: true });
  }

  getTickets(params = {}) {
    return axios.get(this.url, { params });
  }

  getTicket(id) {
    return axios.get(`${this.url}/${id}`);
  }

  translateTicket(id) {
    return axios.post(`${this.url}/${id}/translate`);
  }

  createTicket(data) {
    return axios.post(this.url, data);
  }

  updateTicket(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }
}

export default new TicketsAPI();
